import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ValidationErrorService } from 'src/app/core/services/error/validation-error/validation-error.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
/**
 * Search component for admin control panel
 */
export class SearchComponent implements OnInit, OnDestroy {
  @Input() control!: FormControl<string | null>;
  @Output() searchClick = new EventEmitter<any>();
  @ViewChild('searchTerm') searchTerm!: ElementRef<HTMLInputElement>;
  private subsink = new Subscription();
  error?: string;

  /**
   * Constructor
   */
  constructor(private validationErrorService: ValidationErrorService) {}

  /**
   * Init
   */
  ngOnInit(): void {
    const subscription = this.control.statusChanges.subscribe(() => {
      this.validationErrorService
        .translateError(this.control)
        .then((errorMessage) => {
          this.error = errorMessage;
        });
    });
    this.subsink.add(subscription);
  }

  /**
   * Destroy
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  /**
   * Emits search click
   */
  searchClickAction(): void {
    this.searchClick.emit();
  }

  /**
   * Clears the search bar
   */
  handleClearSearch() {
    this.searchTerm.nativeElement.value = '';
    this.control.reset();
  }
}
